import { HTMLAttributes } from 'react';
import { FieldPath, FieldValues } from 'react-hook-form';
import { TextDanger, TextWarning } from '../../../components/typography';
import { useFormInputMessages } from './useFormInputMessages';

interface FormInputMessagesProps<
  FormData extends FieldValues,
  Name extends FieldPath<FormData>
> extends HTMLAttributes<HTMLDivElement> {
  name: Name;
}

export const FormInputMessages = <
  FormData extends FieldValues,
  Name extends FieldPath<FormData>
>(
  props: FormInputMessagesProps<FormData, Name>
) => {
  const { name, ...rest } = props;
  const messages = useFormInputMessages<FormData, Name>(name);

  return messages.map(({ type, message }, index) => {
    const Text = type === 'warning' ? TextWarning : TextDanger;
    return (
      <Text key={index} as="div" {...rest}>
        {message}
      </Text>
    );
  });
};
